var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "con-exemple-prompt", attrs: { id: "resourceForm" } },
    [
      _c(
        "vs-row",
        [
          _c("vs-col", { attrs: { "vs-w": "12" } }, [
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Nom* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { type: "text", name: "name", required: "" },
                    model: {
                      value: _vm.resource.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "name", $$v)
                      },
                      expression: "resource.name",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Délai de contribution* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { name: "contribution_delay", required: "" },
                    model: {
                      value: _vm.resource.contribution_delay,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "contribution_delay", $$v)
                      },
                      expression: "resource.contribution_delay",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Délai de publication* :")]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "vx-col sm:w-2/3 w-full" },
                [
                  _c("vs-input", {
                    staticClass: "w-full",
                    attrs: { name: "publication_delay", required: "" },
                    model: {
                      value: _vm.resource.publication_delay,
                      callback: function ($$v) {
                        _vm.$set(_vm.resource, "publication_delay", $$v)
                      },
                      expression: "resource.publication_delay",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "vx-row mb-6" }, [
              _c("div", { staticClass: "vx-col sm:w-1/3 w-full" }, [
                _c("span", [_vm._v("Données anonymes* :")]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vx-col sm:w-2/3 w-full" }, [
                _c(
                  "span",
                  { staticClass: "mr-5" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: { "vs-name": "anonymous", "vs-value": true },
                        model: {
                          value: _vm.resource.anonymous,
                          callback: function ($$v) {
                            _vm.$set(_vm.resource, "anonymous", $$v)
                          },
                          expression: "resource.anonymous",
                        },
                      },
                      [_vm._v("Oui")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "mr-5" },
                  [
                    _c(
                      "vs-radio",
                      {
                        attrs: { "vs-name": "anonymous", "vs-value": false },
                        model: {
                          value: _vm.resource.anonymous,
                          callback: function ($$v) {
                            _vm.$set(_vm.resource, "anonymous", $$v)
                          },
                          expression: "resource.anonymous",
                        },
                      },
                      [_vm._v("Non")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }